import { styled, Button } from "@mui/material";

export const StyledButton = styled(Button)(
  ({
    theme,
    height,
    btntype = "primary",
    fontSize,
    isshare,
    padding,
    color,
    border,
    fontWeight,
    isprofile,
  }) => ({
    width: "100%",
    height: height ? height : "100%",
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette.custom[btntype],
    borderRadius: isprofile
      ? theme.borderRadius.radius.wallet
      : isshare
        ? theme.borderRadius.radius.custom
        : theme.borderRadius.radius.wallet,
    fontSize: fontSize,
    padding: padding,
    fontWeight: fontWeight ? fontWeight : theme.typography.fontWeight.bold,
    border: border,
    color: color ? color : theme.palette.custom.white,
    [theme.breakpoints.down("sm")]: {
      height: height ? "40px" : "46px",
      fontSize: theme.typography.tiny.fontSize,
      padding: "5px 20px",
    },
    "&.Mui-disabled": {
      cursor: "not-allowed",
    },
  })
);
